// src/components/NavigationDrawer/ScenarioSection/NavigationDrawerScenarioList/NavigationDrawerCompanyScenariosListItem.tsx

import React from 'react';
import ScenarioListItem from '../ScenarioListItem.tsx';
import type { ScenarioDto } from '@/api-gen/api.schemas';

type NavigationDrawerCompanyScenariosListItemProps = {
  item: ScenarioDto;
  companyId: number;
  handleRightClick: (event: React.MouseEvent<HTMLElement>, scene: ScenarioDto) => void;
  handleSelectScenario: () => void;
  classes: {
    selected: string;
    withB: string;
    withTBP: string;
    sharedScenario: string;
    subMenuWidth: string;
    white: string;
  };
  sceneId: number;
};

const NavigationDrawerCompanyScenariosListItem: React.FC<NavigationDrawerCompanyScenariosListItemProps> = React.memo(
  ({ item, companyId, handleRightClick, handleSelectScenario, classes, sceneId }) => (
    <ScenarioListItem
      scene={item}
      classes={classes}
      companyId={companyId}
      handleRightClick={handleRightClick}
      handleSelectScenario={handleSelectScenario}
      isSelected={item.id === sceneId}
    />
  )
);

NavigationDrawerCompanyScenariosListItem.displayName = 'NavigationDrawerCompanyScenariosListItem';

export default NavigationDrawerCompanyScenariosListItem;
